var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:[
        _vm.baseClass,
        _vm.sizeClass,
        _vm.justifyClass,
        _vm.alignClass,
        _vm.orderClass, 
        _vm.offsetClass ],style:({ paddingLeft: ((_vm.gutter / 2) + "px"), paddingRight: ((_vm.gutter / 2) + "px") })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }